/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Parameter } from './parameter';
import { S3PropertiesLocation } from './s3PropertiesLocation';


export interface JobSignalRequest { 
    /**
     * The job id that uniquely identifies the previously submitted job
     */
    id: string;
    /**
     * The task Id of the receive task in the job workflow to signal. The job must be waiting on this task at the time of this call                
     */
    receiveTaskId: string;
    /**
     * List of key/value pairs that will be made available to the job
     */
    parameters?: Array<Parameter>;
    s3PropertiesLocation?: S3PropertiesLocation;
}
